import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import uuidv1 from 'uuid'
import { uploadPostcards, uploadImage } from '../../api/client'
import ShareMap from '../ShareMapComponent/index'
import DialogAlert from '../common/DialogAlert';
import './index.css';

import { auth } from '../../api/firebase'
import { isLoggedIn } from '../../api/userManagement'

import imageCompression from 'browser-image-compression';

class SharePostcard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: null,
            description: null,
            location: 'none',
            fileName: 'none',
            errorMessage: '',
            wasSubmitClicked: false

        };
        this.fileInput = React.createRef();
    }

    handleChange = (event) => {
        const name = event.target.name;
        this.setState({ [name]: event.target.value });
    }

    handleChangeLocalization = (latlng) => {
        this.setState({ location: latlng })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (e.target.files.length) {
            let file = e.target.files[0].name;
            this.setState({ fileName: file });
        } else { this.setState({ fileName: 'none' }) }

    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            wasSubmitClicked: true,
            errorMessage: 'uploading...'
        })

        const image = uuidv1()
        const { title, description, location } = this.state;
        const author = isLoggedIn() ? auth.currentUser.displayName : "Someone"
        const date = new Date()
        const postcard = { title, description, location, author, image, date }
        if (this.fileInput.current.files[0]) {
            const blob = this.fileInput.current.files[0].slice(0, this.fileInput.current.files[0].size, 'image/jpeg')
            const newFile = new File([blob], image, { type: 'image/jpeg' })
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            }
            const Compression = imageCompression(newFile, options)
            const uploadTask = Compression.then((image) => { return uploadImage(image) })

            uploadTask.then((res) => {
                if (res.state === 'success') {
                    uploadPostcards(this, postcard)
                    this.setState({
                        wasSubmitClicked: true,
                    })
                }
            })
        } else {
            this.setState({
                errorMessage: "File not chosen"
            })
        }

    }

    render() {
        let isSubmitDisabled;
        if (this.state.title !== null
            && this.state.description !== null
            && this.state.location !== 'none'
            && this.state.fileName !== 'none'
            && !this.state.wasSubmitClicked
        ) isSubmitDisabled = false;
        else isSubmitDisabled = true

        return (
            <div className="dashboard-wrapper">
                <form onSubmit={this.handleSubmit} className="formEle">
                    <div className="leftFormEle">
                        <TextField
                            required
                            label="Title"
                            name="title"
                            fullWidth
                            value={this.state.title}
                            margin="normal"
                            onChange={this.handleChange}
                        />

                        <TextField
                            required
                            fullWidth
                            multiline
                            rows="2"
                            label="Description"
                            name="description"
                            value={this.state.description}
                            margin="normal"
                            onChange={this.handleChange}
                            variant="outlined"
                        />

                        <p>Add your picture:</p>

                        <input
                            accept="image/*"
                            id="contained-button-file"
                            className="invisible"
                            multiple
                            type="file"
                            style={{ display: 'none' }}
                            ref={this.fileInput}
                            onChange={(e) => this.handleImageChange(e)}
                        />

                        <label htmlFor="contained-button-file">
                            <Button variant="contained" component="span" >
                                Upload
                        </Button>
                        </label>
                        <Button variant="contained" type="submit" disabled={isSubmitDisabled}>Submit</Button>

                        <p>{this.state.fileName !== 'none' && 'File is choosen.'}</p>
                    </div>

                    <ShareMap changeLoc={this.handleChangeLocalization} />


                </form>
                {this.state.errorMessage}

            </div>
        )
    }
}

export default SharePostcard;
